import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom"
import { Helmet } from "react-helmet-async";
import { config } from '../../config/env';
import Loader from "../../components/modal/Loader"
import Layout from "../../components/layout/Layout"
import ResearchHeader from "../../components/researchheader/ResearchHeader";
import FullImage from "../../components/fullimage/FullImage";
import MarkdownComponent from "../../components/markdowncomponent/MarkdownComponent";

const ResearchPaper = () => {
  const { id: researchPaperID } = useParams();
  const navigate = useNavigate();
  
  const [isLoading, setIsLoading] = useState(true);
  const [researchPaper, setResearchPaper] = useState(null);
  
  useEffect(() => {
    const fetchResearchPaper = async () => {
      setIsLoading(true)
      try {
        const response = await fetch(`${config.apiBaseUrl}/api/v1/content/research_papers/${researchPaperID}`, {
          method: 'GET',
          headers: {
            "Content-Type": "application/json"
          }
        });

        if(!response.ok) {
          throw new Error('Failed to fetch research paper')
        }

        const data = await response.json()
        setResearchPaper(data)
      }
      catch(error) {
        console.log('Error fetching research paper: ', error)
        navigate("/error/404")
      }
      finally {
        setIsLoading(false);
      }
    }
    fetchResearchPaper()
  }, [])

  return (
    <div>
      <Helmet>
        <title>Avanade Research</title>
      </Helmet>
      <Layout>
        {
          researchPaper ? (
            <div>
              <ResearchHeader
                  type={researchPaper.content_type.name}
                  title={researchPaper.title}
                  description={researchPaper.description}
                  date={new Date(researchPaper.created_at).toLocaleDateString()}
                  author={researchPaper.author}
              />
              <div className="mx-auto max-w-[920px] 2xl:max-w-[1400px]">
                <FullImage 
                  image={researchPaper.banner_image_url}
                />
              </div>
              <div className="mb-32 mx-auto max-w-[960px] 2xl:max-w-[1440px]">
                <MarkdownComponent 
                    markdownContent={researchPaper.content} 
                />
              </div>
            </div>
          ) : (<Loader />)
        }
      </Layout>
    </div>
  )
};

export default ResearchPaper;

